import axios from 'axios';

export const fetchVisits = (projectId, params) => axios.get(`/projects/${projectId}/visits`, { params });
export const fetchVisit = (projectId, visitId, params) => axios.get(`/projects/${projectId}/visits/${visitId}`, { params });
export const postSupervision = (projectId, visitId, body) => axios.put(`/projects/${projectId}/visits/${visitId}`, body);
export const fetchOdr = (projectId, visitId) => axios.get(`/projects/${projectId}/visits/${visitId}/odr`);
export const exportVisits = (projectId, params) => new Promise((resolve, reject) => {
  axios.post(`/projects/${projectId}/visits/export`, params)
    .then((res) => {
      // Another truthy HTTP codes can be sent
      if (res.status === 200 || res.status === 202) {
        resolve();
      } else {
        reject();
      }
    })
    .catch((err) => {
      reject(err);
    });
});
